import { pickBy as _pickBy, omit as _omit, isNil as _isNil } from 'lodash'
import queryString from 'query-string'

export default class Query {
  #default_value

  constructor ({ query = {}, default_value = '' } = {}) {
    this.#default_value = default_value

    Object.assign(this, _omit(query, ['collapse']))
  }

  get to_database () {
    return _pickBy(this, value => !_isNil(value) && value !== '')
  }

  get to_url () {
    return _pickBy(this, value => !_isNil(value) && value !== '')
  }

  get to_string () {
    const data = this.to_database
    const keys = Object.keys(data)

    return keys.length ? `?${queryString.stringify(keys.sort().reduce((acc, key) => ({ ...acc, [key]: data[key] }), {}), { arrayFormat: 'bracket' })}` : this.#default_value
  }
}